export function toKebabCase(str: string) {
  return str
    .toLowerCase()
    .replaceAll(/[^\d\s\p{Letter}]/gu, '')
    .trim()
    .replaceAll(/\s+/g, '-');
}
